import defaultParameters from "models/parametersModel";

const useParamsUrl = (paramsFromUrl: any) => {
    const initDefaultParams =JSON.parse(JSON.stringify(defaultParameters));
    let isFilteredFromUrl = false;
    if (paramsFromUrl && Object.keys(paramsFromUrl).length > 0) {
        let lastOrder = 1;
        Object.keys(paramsFromUrl).map((filterName) => {
            const mapValue = paramsFromUrl[filterName];
            const currentFilter = initDefaultParams[filterName];

            if(currentFilter && mapValue !== '')
            {
                initDefaultParams[filterName]['isFiltered'] = true;
                initDefaultParams[filterName]['orderFiltered'] = lastOrder;
                initDefaultParams[filterName]['values'] = mapValue.split("|") || [];
                lastOrder += 1;
                isFilteredFromUrl = true;
            }
        });
    }

    return {
        filtersFromUrl: initDefaultParams,
        paramsFromUrl,
        isFilteredFromUrl
    };
};

export default useParamsUrl;
